<template>
  <div>
    <form-section
      :title="$t('ApplicationForm_Row_ApplicationSettingsTitle')"
      :description="$t('ApplicationForm_Row_AndroidSettingsInfo')"
    >
      <el-row>
        <el-col :span="12">
          <rest-form-item
            prop="android_url"
            :label="$t('ApplicationForm_Field_AndroidUrlLink')"
          >
            <el-input v-model="model.android_url" />
          </rest-form-item>
        </el-col>
        <el-col :span="12">
          <rest-form-item
            prop="android_bundle_id"
            :label="$t('ApplicationForm_Field_AndriodBundleId')"
          >
            <el-input v-model="model.android_bundle_id" />
          </rest-form-item>
        </el-col>
      </el-row>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
export default {
  name: 'ApplicationAndroidFormPage',
  components: { RestFormItem, FormSection },
  props: {
    model: {
      required: true,
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/account/components/ApplicationAndroidFormPage.vue